// src/constants/featureFlags.ts
//
// 2026-08-24・Kazuto発案・CEO室評価・Kazuto最終承認：軌跡マップ（線でつないだ上下の動きで
// 「話を広げたか閉じたか」を表現する機能）は、線グラフの上下という表現形式が「量・強度の増減」を
// 読ませるのには自然でも「開く/閉じる」という質的・方向的な軸には直感的に対応しないという指摘を
// 受け、`/sessions`（自分の回答）・コース（レッスン④）・トップの3箇所すべてでデフォルト非表示に
// する（隣接する円環・棒グラフの信頼性まで巻き添えで疑わしく見えるリスクも判断材料）。
// コード自体は削除せず、この定数をtrueに戻すだけで元通り表示できるようにしておく
// （将来ちゃんとした表現が用意できたときに同じ枠へ差し替える想定）。
// 参照箇所：src/components/LogArea.tsx（/sessions・トップ・コース共通の保存済みセッション表示）、
// src/app/courses/standard/_Lesson4RecordSummary.tsx（レッスン④「今回の記録」内の保存直後表示）。
export const SHOW_TRAJECTORY_MAP = false;
